/// AppLayout: Root layout component with CSS grid for IDE-like structure.
/// Row 1: Toolbar (40px fixed)
/// Row 2: Main content area (flex-1: left sidebar + workspace + right panel)
/// Row 3: Bottom panel area (resizable, for console/variables/jobs)
/// Row 4: Status bar (24px fixed)

import { Toolbar } from "./Toolbar";
import { StatusBar } from "./StatusBar";
import { LeftSidebar } from "./LeftSidebar";
import { RightSidebar } from "./RightSidebar";
import { BottomPanel } from "./BottomPanel";
import { Workspace } from "@/components/workspace/Workspace";
import { useUIStore } from "@/stores/uiStore";

/**
 * Root application layout shell.
 * Provides the IDE grid structure with toolbar, sidebars, workspace,
 * bottom panel, and status bar.
 */
export function AppLayout() {
  const toolbarVisible = useUIStore((s) => s.toolbarVisible);
  const statusBarVisible = useUIStore((s) => s.statusBarVisible);
  const bottomPanelVisible = useUIStore((s) => s.bottomPanelVisible);

  // Build grid template rows dynamically
  const gridRows = [
    toolbarVisible ? "40px" : "0px", // Toolbar
    "1fr", // Main content
    bottomPanelVisible ? "auto" : "0px", // Bottom panel
    statusBarVisible ? "24px" : "0px", // Status bar
  ].join(" ");

  return (
    <div
      data-testid="app-layout"
      className="h-screen w-screen overflow-hidden bg-zinc-900 text-zinc-100"
      style={{ display: "grid", gridTemplateRows: gridRows }}
    >
      {/* Row 1: Toolbar */}
      {toolbarVisible && <Toolbar />}

      {/* Row 2: Main content (left sidebar + workspace + right panel) */}
      <div className="flex min-h-0 overflow-hidden">
        <LeftSidebar />
        {/* Workspace (center) */}
        <Workspace />
        <RightSidebar />
      </div>

      {/* Row 3: Bottom panel (Console, Variables, Jobs, Tasks) */}
      <BottomPanel />

      {/* Row 4: Status bar */}
      {statusBarVisible && <StatusBar />}
    </div>
  );
}
